export default {
    name: "Enq For Pricing",
    meta: {
        icon: "note_add",
        expanded: true,
        auth: true
    },

    departmentName: "Enq. For Pricing",
    finalPagePermision: "Enq_Pricing",

    children: [
        {
            name: "Enq. For Pricing",
            keywords: ['Enq For Pricing'],
            permissionName: 'Enq_Pricing',
            path: "/enqPrice/enqPriceList",
            meta: {
                icon: "note_add",
                auth: true
            },
            component: require("../component/Pricing/enqPriceList.vue"),
            finalPagePermision: "Enq_Pricing",

        },
        {
            name: "Pricing List",
            keywords: ['Pricing List'],
            permissionName: 'Enq. Pricing List',
            permissionName: '',
            path: "/quotation/priceQuotationList",
            meta: {
                icon: "note_add",
                auth: true
            },
            component: require("../component/Pricing/priceQuotationList.vue"),
            finalPagePermision: "",
            finalPagePermision: "Enq. Pricing List",

        },
        {
            name: "Freight Enquiry Export",
            keywords: ['Freight Enquiry'],
            permissionName: 'Freight Enquiry',
            path: "/enqPrice/FreightEnq",
            meta: {
                icon: "note_add",
                auth: true
            },
            component: require("../component/Pricing/freightEnquiryNew.vue"),
            finalPagePermision: "Freight Enquiry",
        },
        // {
        //     name: "Freight Enquiry Import",
        //     keywords: ['Freight Enquiry'],
        //     permissionName: 'Freight Enquiry',
        //     path: "/enqPrice/FreightEnq",
        //     meta: {
        //         icon: "note_add",
        //         auth: true
        //     },
        //     component: require("../component/Pricing/freightEnquiryImp.vue"),
        //     finalPagePermision: "Freight Enquiry",
        // },
        {
            name: "Pricing Engine",
            keywords: ['Pricing Engine'],
            permissionName: 'Pricing_Engine',
            path: "/enqPrice/enqPriceEngineList",
            meta: {
                icon: "note_add",
                auth: true
            },
            component: require("../component/Pricing/enqPriceEngineList.vue"),
            finalPagePermision: "Pricing_Engine",

        },
        {
            name: "Booking Response List",
            path: "/booking-resp-list",
            permissionName: 'Booking Response List',
            keywords: ['Pricing Engine', 'Freight Enquiry', 'Booking Response List'],
            meta: {
                icon: "directions_boat",
                auth: true,
            },
            component: require("../component/Pricing/bookingRespDash.vue"),
            finalPagePermision: "Booking Response List",
        },
        {
            name: "BRF Rate Editor",
            path: "/booking-resp-modify",
            permissionName: 'Booking Response List',
            keywords: ['Pricing Engine', 'Freight Enquiry', 'Booking Response List'],
            meta: {
                icon: "directions_boat",
                auth: true,
            },
            component: require("../component/Pricing/bookingRespDashEdit.vue"),
            finalPagePermision: "Booking Response List",
        },
        {
            name: "BRF Analysis",
            path: "/brf-analysis",
            permissionName: 'Console_Booking_Dash',
            keywords: ['Console Booking Details ', 'Console_Booking_Dash', 'BRF Analysis'],
            meta: {
                icon: "directions_boat",
                auth: true,
            },
            component: require("../component/Pricing/BRFVesselList.vue"),
            finalPagePermision: "Console_Booking_Dash",
        },
        {
            name: "BRF Template",
            path: "/booking-resp-template",
            permissionName: 'Console_Booking_Dash',
            keywords: ['Console Booking Details ', 'Console_Booking_Dash', 'BRF Template'],
            meta: {
                icon: "directions_boat",
                auth: true,
            },
            component: require("../component/Pricing/bookingRespTemplate.vue"),
            finalPagePermision: "Console_Booking_Dash",
        },
        {
            name: "Pricing Engine Log",
            keywords: ['Pricing Engine Log'],
            permissionName: 'Pricing_Engine_Log',
            path: "/enqPrice/enqPriceEngineLogList",
            meta: {
                icon: "note_add",
                auth: true
            },
            component: require("../component/Pricing/enqPriceEngineLogList.vue"),
            finalPagePermision: "Pricing_Engine_Log",

        },
    ]
};


// WEBPACK FOOTER //
// ./src/sidebar/enqPricing.js